/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { ReactNode, useEffect, useState } from 'react';
import { Box, IBoxProps, Skeleton } from 'native-base';
import { faHeart, faStar } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartOutline } from '@fortawesome/free-regular-svg-icons';

import Image from './Image';
import Loading from './Loading';
import { SpIcon } from './Icon';
import Pressable from './Pressable';
import { Caption } from './Typography';
import { useItemCardStyles } from './styles';
import { TypographyProps } from '@springbig/shared';

export type ItemCardProps = {
    handleCallback: (id: number, title?: string, interest?: string) => void;
    id?: number
    title?: string
    imageUrl?: string
    boxProps?: IBoxProps
    checked?: boolean
    needsMark?: boolean
    isDisabled?: boolean
    interest?: string
    loadingComponent?: boolean
    customImageWidth?: number,
    testID?: string;
    captionStyle?: TypographyProps;
}

type ItemCardStyledContainerProps = {
    children: ReactNode;
    boxProps?: IBoxProps;
  }

const ItemCardStyledContainer = ({
    children,
    boxProps,
}: ItemCardStyledContainerProps) => {
    const {
        box_background,
        box_border
    } = useItemCardStyles();

    return <Box
        {...boxProps}
        bg={box_background}
        borderColor={box_border}
        borderWidth={0.25}
        borderTopRadius={12}
        borderBottomRadius={12}
        p={1}
    >
        {children}
    </Box>;
};

const ItemCard = ({
    handleCallback,
    id,
    title,
    imageUrl,
    checked,
    isDisabled,
    boxProps,
    interest,
    loadingComponent,
    customImageWidth,
    testID,
    needsMark = false,
    captionStyle
}: ItemCardProps) => {

    const [isChecked, setIsChecked] = useState<boolean>(false);

    const {
        box_paragraph_text,
        heart_empty_icon_color,
        heart_filled_icon_color,
        star_icon_color
    } = useItemCardStyles();
    useEffect(() => {

        if (!isDisabled) {
            setIsChecked(false);
        }

    }, [isDisabled]);

    return (
        <ItemCardStyledContainer
            {...boxProps}
        >
            <Loading
                isLoading={isChecked}
                borderRadius={12}
            />
            <Pressable
                testID={testID}
                onPress={() => {

                    if (loadingComponent) {
                        setIsChecked(true);
                    }

                    handleCallback(id!, title, interest);
                }}
                borderTopRadius={12}
                borderBottomRadius={12}
                key={id}
                alignItems='center'
                isDisabled={isDisabled}
            >
                <Box
                    borderTopRadius={12}
                    borderBottomRadius={12}
                    position={'relative'}
                >
                    {imageUrl ? (
                        <Image
                            size={'100%'}
                            w={customImageWidth || 40}
                            h={40}
                            style={{ aspectRatio: 1 }}
                            borderTopRadius={12}
                            uri={`${imageUrl}`}
                        />
                    ) : (
                        <Box
                            w={customImageWidth || 40}
                            h={40}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <SpIcon
                                icon={faStar}
                                size={120}
                                color={star_icon_color}
                            />
                        </Box>
                    )}
                    {needsMark && (
                        <Box position={'absolute'} bottom={'1'} right={'2'}>
                            {
                                checked ? (
                                    <SpIcon
                                        size={16}
                                        color={heart_filled_icon_color}
                                        icon={faHeart}
                                    />
                                ) : (
                                    <SpIcon
                                        size={16}
                                        color={heart_empty_icon_color}
                                        icon={faHeartOutline}
                                    />
                                )
                            }
                        </Box>)
                    }
                </Box>
                <Box
                    w={40}
                    h={16}
                    // p={2}
                    justifyContent={'center'}
                >
                    <Caption
                        color={box_paragraph_text}
                        textAlign={'center'}
                        numberOfLines={2}
                        ellipsizeMode={'tail'}
                        {...captionStyle}
                    >
                        {title}
                    </Caption>
                </Box>
            </Pressable>
        </ItemCardStyledContainer>
    );
};

export const ItemCardSkeleton = () => {

    return (
        <ItemCardStyledContainer  boxProps={{ alignItems: 'center', p: 4 , m: 4, borderRadius: 5 }}>
            <Skeleton w={140} h={140} isLoaded={false}  borderTopRadius={10}/>
            <Skeleton.Text lines={1} px="4" isLoaded={false} paddingY={6} />
        </ItemCardStyledContainer>
    );
};

export default ItemCard;
